import styled from 'styled-components'

export const Modal = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(29, 31, 42, 0.9);
  justify-content: center;
  align-items: center;
  display: flex;
  z-index: 10000;
  opacity: 0;
  transition: visibility 0.5s, opacity 0.5s ease;
  visibility: ${({ isOpen }) => {
    if (isOpen) {
      return 'visible'
    }
    return 'hidden'
  }};
  opacity: ${({ isOpen }) => {
    if (isOpen) {
      return '1'
    }
    return '0'
  }};
`

export const ModalContainer = styled.div`
  width: 100%;
  z-index: 10000;
  max-width: 477px;
  background-color: rgba(16, 16, 44, 0.7);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(73, 158, 255, 0.3);
  padding: 42px 40px 40px;
  position: relative;
  border-radius: 20px;
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  @media (max-width: 768px) {
    max-width: 336px;
    border-radius: 12px;
    padding: 24px;
  }
`

export const ModalButtonContainer = styled.div`
  position: absolute;
  background-color: #0f0e2c;
  border: 1px solid rgba(73, 158, 255, 0.3);
  top: -1px;
  right: -60px;
  border-radius: 20px;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
  @media (max-width: 768px) {
    top: -65px;
    right: 0px;
    width: 52px;
    height: 52px;
  }
`

export const ModalCloseButton = styled.img`
  width: 14px;
  height: 14px;
`
export const ModalTitle = styled.h2`
  color: white;
  font-size: 24px;
  font-style: italic;
  font-weight: 700;
  line-height: 40px;
  letter-spacing: 1px;
  text-align: left;
  margin: 0 0 16px;
  text-transform: uppercase;
  @media (max-width: 768px) {
    margin-bottom: 24px;
  }
`
export const ModalForm = styled.form`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ModalInputContainer = styled.div`
  box-sizing: border-box;
  position: relative;
  margin-bottom: 30px;
  width: 100%;
`

export const ModalInputLabel = styled.label`
  box-sizing: border-box;
  display: block;
  color: #a3a4a9;
  position: absolute;
  top: 18px;
  left: 23px;
  padding: 1px;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.4px;
  @media (max-width: 768px) {
    font-size: 10px;
    line-height: 15px;
    letter-spacing: 0.5px;
    top: 10px;
    left: 16px;
  }
`
export const ModalInput = styled.input`
  font-family: 'OpenSans';
  display: block;
  font-size: 24px;
  width: 100%;
  box-sizing: border-box;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0.5px;
  padding: 40px 110px 18px 24px;
  color: white;
  background-color: ${({ invalid }) => {
    if (invalid) {
      return '#ED49151A '
    }
    return 'inherit'
  }};
  background-clip: padding-box;
  border: 1px solid #2f313b;
  border-color: ${({ invalid }) => {
    if (invalid) {
      return '#322328'
    }
    return '#2f313b'
  }};
  border-radius: 20px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  &::placeholder {
    color: #a3a4a9;
    opacity: 0.4;
  }
  &:focus {
    color: white;
    outline: 0;
    box-shadow: 0 0 0 1px rgba(158, 158, 158, 0.25);
  }
  &:disabled {
    background-color: #262a35;
    color: #a3a4a9;
  }
  @media (max-width: 768px) {
    font-size: 14px;
    max-width: 310px;
    font-weight: 500;
    line-height: 21px;
    letter-spacing: 0.5px;
    border-radius: 12px;
    padding: 26px 75px 10px 16px;
  }
`
export const ModalText = styled.div`
  display: flex;
  margin-right: auto;
  gap: 16px;
  justify-content: start;
  width: 100%;
  color: white;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.4px;
  text-align: left;
  @media (max-width: 768px) {
    font-size: 14px;
  }
`

export const ModalTextWrapper = styled.span`
  font-weight: 700;
`

export const ModalTextDescription = styled.span`
  min-width: 130px;
`
export const ModalError = styled.div`
  margin-left: 10px;
  color: red;
  font-size: 12px;
  position: absolute;
  width: 110%;
`

export const StakeMaxButtonWrapper = styled.div`
  position: absolute;
  top: 26px;
  right: 24px;
  @media (max-width: 768px) {
    top: 14px;
    right: 16px;
  }
`

export const ModalTxText = styled.p`
  width: max-content;
  color: white;
  margin: 24px auto 20px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
`

export const ModalTxLink = styled.a`
  width: max-content;
  color: white;
  margin: 24px auto 20px;
  display: block;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
`
export const ModalSpinnerWrapper = styled.div`
  margin-top: 60px;
  @media (max-width: 768px) {
    margin-top: 48px;
  }
`

export const ModalButtonWrapper = styled.div`
  margin-top: 25px;
  @media (max-width: 768px) {
    margin-top: 17px;
  }
`
